module.exports = __webpack_public_path__ + "static/media/26UNRWA23.ff57d22d.jpg";